import VacationsView from '../VacationsView.vue'
import VacationRequestList from '../Pages/VacationRequestList.vue'
import VacationRequestCreate from '../Pages/VacationRequestCreate.vue'
import VacationRequestDetail from '../Pages/VacationRequestDetail.vue'
import VacationCalendar from '../Pages/VacationCalendar.vue'
import VacationHistory from '../Pages/VacationHistory.vue'

const routes = [
  {
    path: '/vacaciones',
    component: VacationsView,
    children: [
      {
        path: 'solicitudes',
        name: 'vacation-requests-list',
        component: VacationRequestList,
      },
      {
        path: 'solicitudes/crear',
        name: 'vacation-requests-create',
        component: VacationRequestCreate,
      },
      {
        path: 'solicitudes/:id',
        name: 'vacation-requests-detail',
        component: VacationRequestDetail,
      },
      {
        path: 'calendario',
        name: 'vacation-calendar',
        component: VacationCalendar,
      },
      {
        path: 'historial',
        name: 'vacation-history',
        component: VacationHistory,
      },
    ]
  }
]

export default routes
